(function () {
  const select = document.getElementById('orderTypeStatus') as HTMLSelectElement;
  const allRows: NodeListOf<HTMLDivElement> = document.querySelectorAll('.trade-account-single-order');

  if (!select || allRows?.length <= 0) {
    return;
  }

  const filterRows = (rows, value) => {
    rows.forEach((row: HTMLElement) => {
      const rowVal = row.getAttribute('data-order-type').trim();

      if (value === 'ALL' || value === rowVal) {
        row.style.display = 'block';
      } else {
        row.style.display = 'none';
      }
    });
  };

  select.addEventListener('change', (e) => {
    e.preventDefault();

    const { value } = select.options[select.selectedIndex];

    filterRows(allRows, value);
  });
})();
